import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Modal as ReactModal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { eventSelected } from "../../../state/events/actions";
import { EVENT, PLAYER } from "../../../constants";

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  openCloseModal: PropTypes.func.isRequired,
  event: PropTypes.shape({
    id: PropTypes.number,
    streamType: PropTypes.string,
    ppv: PropTypes.bool
  })
};

const defaultProps = {
  event: null
};

function RegisterModal(props) {
  const { isOpen, openCloseModal, event } = props;
  const history = useHistory();
  const location = useLocation();
  const params = useParams();

  const handleClick = (redirectType) => {
    openCloseModal(!isOpen);
    eventSelected(event);
    const pathName = `/${params.shortName}/${PLAYER}/${EVENT}/${event.id}/${event.streamType}`;
    const queryParams = new URLSearchParams(location.search);
    queryParams.set("redirectTo", redirectType);

    history.push(`${pathName}?${queryParams.toString()}`);
  };

  const toggle = () => {
    openCloseModal(!isOpen);
  };

  return (
    <ReactModal centered isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Hello, guest!</ModalHeader>
      <ModalBody>Register for a FREE account to view this video.</ModalBody>
      <ModalFooter>
        <Button
          style={{ marginRight: "0.25rem" }}
          color="success"
          onClick={() => handleClick("create")}
        >
          Create Account
        </Button>
        <Button onClick={() => handleClick("signin")}>Sign In</Button>
      </ModalFooter>
    </ReactModal>
  );
}

RegisterModal.propTypes = propTypes;
RegisterModal.defaultProps = defaultProps;

export default RegisterModal;
